import ArrowBtn from 'components/buttons/ArrowBtn'
import useFetchedData from 'hooks/useFetchedData'
import useTranslation from 'hooks/useTranslation'
import ErrorComponent from 'components/Error'
import Popup from 'components/popups/Popup'
import Loading from 'components/Loading'
import DeviceItem from './DeviceItem'
import { DELETE } from 'rest/request'
import { devices } from 'rest/urls'
import { useState } from 'react'

export interface Device {
  object: string
  id: number
  clientIp: string
  identifier: string
  userId: string
  clientLocation: string
  deviceName: string
  name?: string
  lastAccess: string
  isActualDevice: boolean
  isAuthorised: boolean
  webauthns: any[]
}

const DevicePopup = () => {
  const [isDeleting, setDeleting] = useState(false)
  const { isLoading, data, setData } = useFetchedData<Device[]>(devices, 'data', 'GET')
  const { t } = useTranslation('account')

  const deleteAllDevices = async () => {
    if (isDeleting) return
    setDeleting(true)
    try {
      const response = await DELETE(devices)
      if (response) {
        setData([])
        setDeleting(false)
      } else {
        throw new Error('Wrong response')
      }
    } catch (error) {
      setDeleting(false)
    }
  }

  return (
    <Popup>
      <div className='popup__device'>
        <div className='popup__title --sticky'>
          <div>{t('authorizedDevices')}</div>
        </div>

        <div className='device__main account__list'>
          {isLoading
            ? <Loading />
            : Array.isArray(data) && data.length > 0
              ? data.map((device) => <DeviceItem
                {...device}
                key={device.id}
                setData={setData}
              />)
              : <ErrorComponent
                staticPos
                text={Array.isArray(data) ? t('noItem') : undefined}
              />}
        </div>

        {Array.isArray(data) && data.length > 0 && <ArrowBtn
          enlarged
          text='Usuń wszystkie'
          isLoading={isDeleting}
          action={deleteAllDevices}
        />}
      </div>
    </Popup>
  )
}

export default DevicePopup